module.exports = __webpack_public_path__ + "img/gongye-1.da9a1692.jpg";